import React from "react";
import { useNavigate } from "react-router-dom";
import "./TopHeader.css";
import { apiCall } from "../../api/apiCall";
import { useQuery } from "@tanstack/react-query";
import { User } from "../../models/user";
import { Bell } from "lucide-react";
import { useTranslation } from "../../i18n/UseTranslation";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

interface AppNotification {
  uuid: string;
  is_read: boolean;
}

const TopHeader: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translations = t.topHeader;

  const [isAuthReady, setIsAuthReady] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthReady(true);
      setIsAuthenticated(!!user);
    });
    return () => unsubscribe();
  }, []);

  const { data: currentUser } = useQuery<User, Error>({
    queryKey: ["fetchCurrentUser"],
    queryFn: async () => apiCall<User>("/users/me", { method: "GET" }),
    enabled: isAuthReady && isAuthenticated,
  });

  const { data: unreadNotifications = [] } = useQuery<AppNotification[], Error>(
    {
      queryKey: ["fetchUnreadCount"],
      queryFn: async () =>
        apiCall<AppNotification[]>("/notifications?is_read=false", {
          method: "GET",
        }),
      enabled: !!currentUser && isAuthReady && isAuthenticated,
      refetchInterval: 30000,
      refetchOnWindowFocus: true,
    },
  );

  const unreadCount = unreadNotifications.length;

  const userToGlimpse = currentUser as any;
  const userSubscription =
    userToGlimpse?.Company?.Subscription ||
    userToGlimpse?.company?.Subscription ||
    userToGlimpse?.company?.subscription;

  const currentPlan =
    userSubscription?.status === "active" ? userSubscription.plan_code : "free";

  return (
    <header className="top-header">
      <div className="top-header-right">
        {currentPlan === "free" && (
          <button className="upgrade-btn" onClick={() => navigate("/upgrade")}>
            <span className="upgrade-badge">⭐ PLUS</span>
            <span className="upgrade-text">{translations.activateTrial}</span>
          </button>
        )}

        <button
          className="icon-btn notification-btn"
          onClick={() => navigate("/notifications")}
          aria-label="Voir les notifications"
        >
          <Bell size={22} />

          {unreadCount > 0 && (
            <span className="notification-dot">{unreadCount}</span>
          )}
        </button>
      </div>
    </header>
  );
};

export default TopHeader;
